/** Header "Show data for" filter (FR-ADM-07): all visible systems, or one system. Remembered per browser. */
import { create } from 'zustand';

const KEY = 'uatp.admin.scope';

function read(): string | null {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

interface ScopeState {
  systemId: string | null;
  setSystemId: (id: string | null) => void;
}

export const useScope = create<ScopeState>((set) => ({
  systemId: read(),
  setSystemId: (systemId) => {
    try {
      if (systemId) localStorage.setItem(KEY, systemId);
      else localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
    set({ systemId });
  },
}));
